"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingTemplate = void 0;
const close_icon_svg_1 = __importDefault(require("./close-icon.svg"));
const trackingTemplate = () => `
  <div class="tracking-container wf-section">
    <div id="shipment-tracking-block" data-gjs-type="shipment-tracking" data-gjs-highlightable="false" data-gjs-copyable="false" data-gjs-droppable="false">
      <div data-js-page="page1">
        <div class="tracking-container-bg"></div>
        <div class="malomo-shipment-tracker">
          <div class="malomo-shipment-tracker-header">
            <p class="malomo-shipment-tracker-delivery-state">Estimated Delivery</p>
            <h1 class="malomo-shipment-tracker-status-message">Monday September 30</h1>
            <h1 class="malomo-shipment-tracker-delivery-date">Out for Delivery</h1>
          </div>
          <div class="malomo-shipment-tracker-body">
            <h1 class="malomo-shipment-tracker-countdown">3 days left</h1>
            <div class="malomo-shipment-tracker-history">
              <div class="malomo-shipment-tracker-latest-activity">Latest Activity</div>
              <div class="malomo-shipment-tracker-most-recent-event">
                <div class="malomo-shipment-tracker-event">
                  <div class="malomo-shipment-tracker-event-timestamp">
                    <div class="malomo-shipment-tracker-event-timestamp-date">Sept 28</div>
                    <div class="malomo-shipment-tracker-event-timestamp-time">12:39 PM</div>
                  </div>
                  <div class="malomo-shipment-tracker-event-message">Accepted by local Post Office, on its way to the
                    destination</div>
                  <div class="malomo-shipment-tracker-event-location">
                    <div class="malomo-shipment-tracker-event-location-city">Fort Lauderdale,</div>
                    <div class="malomo-shipment-tracker-event-location-state">FL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="malomo-shipment-tracker-footer">
            <div class="malomo-shipment-tracker-carrier-info"><img
                src="https://uploads-ssl.webflow.com/5ce3005fdb14782251ef74ea/5ce5851dce3f6b43e63006ef_ups.png"
                height="20" alt="" class="malomo-shipment-tracker-carrier-info-image" /><a href="#"
                class="malomo-shipment-tracker-carrier-info-tracking-code-link">9400110200864745655986</a></div><a
              href="#" class="malomo-shipment-tracker-history-control">Show History</a>
          </div>
        </div>
        <div class="malomo-unavailable">
          <div class="malomo-unavailable-header">Unavailable</div>
          <div class="malomo-unavailable-body">
            <div class="malomo-unavailable-message">Tracking information is unavailable at this time. You can try
              entering your tracking number into your carrier&#039;s website for more information.</div>
            <div class="malomo-unavailable-links"><a href="https://www.ups.com/tracking.html" target="_blank"
                class="malomo-unavailable-link">Check with UPS</a><br /><a
                href="https://tools.usps.com/go/TrackConfirmAction_input" target="_blank"
                class="malomo-unavailable-link">Check with USPS</a><br /><a
                href="https://www.fedex.com/en-us/tracking.html" target="_blank" class="malomo-unavailable-link">Check
                with FedEx</a><br /><a href="https://ecommerceportal.dhl.com/track/" target="_blank"
                class="malomo-unavailable-link">Check with DHL eCommerce</a></div>
          </div>
        </div>
      </div>
      <div data-js-page="page2">
        <div class="tracking-container-bg"></div>
        <div class="malomo-order-lookup">
          <div class="malomo-order-lookup-header">
            <div class="malomo-order-lookup-error-message">We are having trouble locating your order. Please try
              re-entering your order details. If you haven&#039;t received your shipping details yet, it&#039;s
              possible your order is still being fulfilled and you won&#039;t be able to track your order yet.</div>
          </div>
          <div class="malomo-order-lookup-body wf">
            <form id="email-form" name="email-form" data-name="Email Form" class="malomo-order-lookup-form"
              action="/">
              <div class="malomo-order-lookup-section-1">
                <div class="malomo-order-lookup-section-1-1"><label for="Fieldmalomo-order-lookup-number"
                    class="malomo-order-lookup-label">Order Number</label><input type="text" maxlength="256"
                    name="Fieldmalomo-order-lookup-number" data-name="Fieldmalomo-order-lookup-number"
                    id="Fieldmalomo-order-lookup-number" required class="malomo-order-lookup-number-input w-input" />
                </div>
                <div class="malomo-order-lookup-section-1-2"><label for="malomo-order-lookup-customer-email"
                    class="malomo-order-lookup-label">Email Address</label><input type="text" maxlength="256"
                    name="malomo-order-lookup-customer-email" data-name="malomo-order-lookup-customer-email"
                    id="malomo-order-lookup-customer-email" required
                    class="malomo-order-lookup-customer-email-input w-input" /></div>
              </div>
              <div class="malomo-order-lookup-section-separator">or</div>
              <div class="malomo-order-lookup-section-2"><label for="malomo-order-lookup-tracking-number"
                  class="malomo-order-lookup-label">Tracking Number</label><input type="text" maxlength="256"
                  name="malomo-order-lookup-tracking-number" data-name="malomo-order-lookup-tracking-number"
                  id="malomo-order-lookup-tracking-number" required
                  class="malomo-order-lookup-tracking-number-input w-input" /></div><input type="submit"
                value="Track Your Order" data-wait="Please wait..."
                class="malomo-order-lookup-submit-button w-button" />
            </form>
            <div class="w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div class="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </div>
      </div>
      <div data-js-page="page3">
        <div class="malomo-shipment-tracker">
          <div class="malomo-shipment-tracker-header">
            <p class="malomo-shipment-tracker-delivery-state">Estimated Delivery</p>
            <h1 class="malomo-shipment-tracker-status-message">Monday September 30</h1>
            <h1 class="malomo-shipment-tracker-delivery-date">Out for Delivery</h1>
          </div>
          <div class="malomo-shipment-tracker-body">
            <h1 class="malomo-shipment-tracker-countdown">3 days left</h1>
            <div class="malomo-shipment-tracker-history">
              <div class="malomo-shipment-tracker-latest-activity">Latest Activity</div>
              <div class="malomo-shipment-tracker-most-recent-event">
                <div class="malomo-shipment-tracker-event">
                  <div class="malomo-shipment-tracker-event-timestamp">
                    <div class="malomo-shipment-tracker-event-timestamp-date">Sept 28</div>
                    <div class="malomo-shipment-tracker-event-timestamp-time">12:39 PM</div>
                  </div>
                  <div class="malomo-shipment-tracker-event-message">Accepted by local Post Office, on its way to the
                    destination</div>
                  <div class="malomo-shipment-tracker-event-location">Fort Lauderdale, FL</div>
                </div>
              </div>
              <div class="malomo-shipment-tracker-events-backdrop">
                <div class="malomo-shipment-tracker-events-modal">
                  <div class="malomo-shipment-tracker-events-header">
                    <div class="malomo-shipment-tracker-events-header-label">History<br />
                    </div>
                    <div class="malomo-shipment-tracker-events-header-close"><img
                        src=${close_icon_svg_1.default} loading="lazy" height="20" alt=""
                        class="malomo-shipment-tracker-events-header-close-icon" /></div>
                  </div>
                  <div class="malomo-shipment-tracker-events">
                    <div class="malomo-shipment-tracker-event">
                      <div class="malomo-shipment-tracker-event-timestamp">
                        <div class="malomo-shipment-tracker-event-timestamp-date">Sept 28</div>
                        <div class="malomo-shipment-tracker-event-timestamp-time">12:39 PM</div>
                      </div>
                      <div class="malomo-shipment-tracker-event-message">Accepted by local Post Office, on its way to
                        the destination</div>
                      <div class="malomo-shipment-tracker-event-location">
                        <div class="malomo-shipment-tracker-event-location-city">Fort Lauderdale,</div>
                        <div class="malomo-shipment-tracker-event-location-state">FL</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="malomo-shipment-tracker-footer">
            <div class="malomo-shipment-tracker-carrier-info"><img
                src="https://uploads-ssl.webflow.com/5ce3005fdb14782251ef74ea/5ce5851dce3f6b43e63006ef_ups.png"
                height="20" alt="" class="malomo-shipment-tracker-carrier-info-image" /><a href="#"
                class="malomo-shipment-tracker-carrier-info-tracking-code-link">9400110200864745655986</a></div><a
              href="#" class="malomo-shipment-tracker-history-control">Show History</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <script src="https://js.gomalomo.com/v2/" type="text/javascript"></script>
`;
exports.trackingTemplate = trackingTemplate;
